__turbopack_context__.v({
  "articleCard": "page-module__jXZM3G__articleCard",
  "articleColumn": "page-module__jXZM3G__articleColumn",
  "articleContent": "page-module__jXZM3G__articleContent",
  "articleCount": "page-module__jXZM3G__articleCount",
  "articleDescription": "page-module__jXZM3G__articleDescription",
  "articleLink": "page-module__jXZM3G__articleLink",
  "articleLinkWithCover": "page-module__jXZM3G__articleLinkWithCover",
  "articleMedia": "page-module__jXZM3G__articleMedia",
  "articles": "page-module__jXZM3G__articles",
  "contentGrid": "page-module__jXZM3G__contentGrid",
  "contentSection": "page-module__jXZM3G__contentSection",
  "eyebrow": "page-module__jXZM3G__eyebrow",
  "hero": "page-module__jXZM3G__hero",
  "heroContainer": "page-module__jXZM3G__heroContainer",
  "heroGlow": "page-module__jXZM3G__heroGlow",
  "intro": "page-module__jXZM3G__intro",
  "page": "page-module__jXZM3G__page",
  "pagination": "page-module__jXZM3G__pagination",
  "paginationArrow": "page-module__jXZM3G__paginationArrow",
  "paginationPage": "page-module__jXZM3G__paginationPage",
  "paginationPages": "page-module__jXZM3G__paginationPages",
  "sectionHeading": "page-module__jXZM3G__sectionHeading",
  "sectionLabel": "page-module__jXZM3G__sectionLabel",
  "sidebar": "page-module__jXZM3G__sidebar",
  "sidebarCard": "page-module__jXZM3G__sidebarCard",
  "sidebarIntro": "page-module__jXZM3G__sidebarIntro",
  "summaryLink": "page-module__jXZM3G__summaryLink",
  "summaryMore": "page-module__jXZM3G__summaryMore",
  "summaryTitle": "page-module__jXZM3G__summaryTitle",
  "title": "page-module__jXZM3G__title",
});
